import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import { inventorySparesTableColumnsConfig } from "./inventorySparesTableColumnDef";
import { Table } from "../../../../component/table/Table";

import { toast } from "react-toastify";
import { inventorySparesDownloadRequest } from "../../../../http-request/inventory/inventoryDownloadFile";
import { InventorySpareForm } from "../../../../component/inventory/spares/inventorySpareForm/InventorySpareForm";
import { Modal } from "../../../../component/inventory/spares/modal/Modal";
import {
  useApproveRequestMutation,
  useRejectRequestMutation,
} from "../../../../services/inventory/spares/inventorySpareMutationSlice";
import { useSelector } from "react-redux";
import { selectInventorySpareFilterState } from "../../../../store/inventory/inventorySparesSlice";
import {
  selectInventorySpares,
  useDeleteInventorySpareByIdMutation,
  useGetInventorySparesListQuery,
} from "../../../../services/inventory/spares/inventorySpareApiSlice";
import { CategoryPageSkeleton } from "../../../../component/skeleton/CategoryPageSkeleton";

export const InventorySparesTablePage = () => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);
  const navigate = useNavigate();

  const filters = useSelector(selectInventorySpareFilterState);

  const { isLoading, isSuccess, isFetching } = useGetInventorySparesListQuery({
    seller_id: filters.seller_id,
    status: filters.status,
  });

  const tableData = useSelector(selectInventorySpares);

  const [deleteInventorySpare, { isLoading: isDeleting }] =
    useDeleteInventorySpareByIdMutation();

  /* -------- handlers required by column config -------- */

  const handleNavigateToLotList = useCallback(
    (requestId) => {
      navigate(`/inventory/spares/${requestId}`);
    },
    [navigate],
  );

  const handleDownload = useCallback(async (requestId) => {
    try {
      toast.success("downloading...");
      const fileData = await inventorySparesDownloadRequest({
        category: "spares",
        requestId: requestId,
      });

      const contentType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const blob = new Blob([fileData], { type: contentType });

      // Create a temporary link element
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `mobiGarage_${requestId}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("Error occurred during download:", err);
      toast.success("error while downloading");
    }
  }, []);

  const handleDelete = useCallback((requestId) => {
    setSelectedDeleteId(requestId);
    setIsDeleteModalOpen(true);
  }, []);

  const confirmDelete = async () => {
  try {
    await deleteInventorySpare(selectedDeleteId).unwrap();
    toast.success("Deleted successfully");
    setIsDeleteModalOpen(false);
    setSelectedDeleteId(null);
  } catch (error) {
    toast.error("Failed to delete");
  }
};

  const columnDefs = useMemo(
    () =>
      inventorySparesTableColumnsConfig(
        handleDownload,
        handleNavigateToLotList,
        handleDelete,
      ),
    [handleDownload, handleNavigateToLotList, handleDelete],
  );

  return isSuccess ? (
    <><Table
      data={tableData}
      columns={columnDefs}
      loading={isLoading}
      isFetching={isFetching} /><Modal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        title="Delete Inventory Request"
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <p style={{ fontSize: "14px", color: "#475569" }}>
            Are you sure you want to delete this inventory request?
            This action cannot be undone.
          </p>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
            <button
              onClick={() => setIsDeleteModalOpen(false)}
              style={{
                padding: "6px 14px",
                borderRadius: "6px",
                border: "1px solid #CBD5E1",
                background: "#F8FAFC",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>

            <button
              onClick={confirmDelete}
              disabled={isDeleting}
              style={{
                padding: "6px 14px",
                borderRadius: "6px",
                border: "none",
                background: "#DC2626",
                color: "#fff",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              {isDeleting ? "Deleting..." : "Delete"}
            </button>
          </div>
        </div>
      </Modal></>
  ) : (
    <CategoryPageSkeleton />
  );
};
